import { getWsBaseUrl } from "./wsUrl";

/** Broadcast support WS events to React via window CustomEvent("support-ws"). */
export function connectSupportSocket({ role = "user", token } = {}) {
  const wsBase = getWsBaseUrl();
  let socket;
  let pingInterval;
  let reconnectTimer;
  let unmounted = false;

  const authToken =
    token ||
    (role === "admin"
      ? localStorage.getItem("adminToken") || localStorage.getItem("token")
      : localStorage.getItem("token"));

  const connect = () => {
    socket = new WebSocket(wsBase);
    socket.onopen = () => {
      if (authToken) {
        socket.send(JSON.stringify({ type: "auth", token: authToken }));
      }
      pingInterval = setInterval(() => {
        if (socket.readyState === WebSocket.OPEN) {
          socket.send(JSON.stringify({ type: "ping" }));
        }
      }, 30000);
    };
    socket.onmessage = (event) => {
      let data;
      try {
        data = JSON.parse(event.data);
      } catch {
        return;
      }
      if (data?.type === "support_message" || data?.type === "support_issue") {
        window.dispatchEvent(new CustomEvent("support-ws", { detail: data }));
      }
    };
    socket.onclose = () => {
      clearInterval(pingInterval);
      if (!unmounted) reconnectTimer = setTimeout(connect, 8000);
    };
    socket.onerror = () => {
      try {
        socket.close();
      } catch {
        /* ignore */
      }
    };
  };

  connect();

  return () => {
    unmounted = true;
    clearInterval(pingInterval);
    clearTimeout(reconnectTimer);
    try {
      socket?.close();
    } catch {
      /* ignore */
    }
  };
}
